let direction = 'ltr';

export const dezThemeSet = [
	{ /* Default */
		typography: "opensans",
		version: "light",
		layout: "vertical",
		headerBg: "color_1",
		navheaderBg: "color_1",
		sidebarBg: "color_1",
		sidebarStyle: "full",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "full",
		direction: direction
	},
	{ /* Demo Theme 1 */
		typography: "opensans",
		version: "light",
		layout: "vertical",
		navheaderBg: "color_5",
		headerBg: "color_1",
		sidebarStyle: "full",
		sidebarBg: "color_12",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_5",
		direction: direction
	},
	 { /* Demo Theme 2 */
		typography: "opensans",
		version: "light",
		layout: "vertical",
		navheaderBg: "color_2",
		headerBg: "color_2",
		sidebarStyle: "full",
		sidebarBg: "color_1",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_2",
		direction: direction
	},
	{
		/* Demo Theme 3 */
		typography: "opensans",
		version: "light",
		layout: "vertical",
		navheaderBg: "color_10",
		headerBg: "color_1",
		sidebarStyle: "modern",
		sidebarBg: "color_10",
		sidebarPosition: "static",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_10",
		direction: direction
	},
	{
		/* Demo Theme 4 */	
		typography: "opensans",
		version: "light",
		layout: "horizontal",
		navheaderBg: "color_1",
		headerBg: "color_1",
		sidebarStyle: "full",
		sidebarBg: "color_3",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_3",
		direction: direction
		
	},
	{
		/* Demo Theme 5 */
		typography: "opensans",
		version: "dark",
		layout: "vertical",
		navheaderBg: "color_15",
		headerBg: "color_1",
		sidebarStyle: "mini",
		sidebarBg: "color_15",
		sidebarPosition: "fixed",
		headerPosition: "fixed",
		containerLayout: "wide",
		primary: "color_15",
		direction: direction
	},
	
];
	